import React from "react";
import styled from "styled-components";

interface Props {
  width: string;
  backgroundColor: string;
  textColor: string;
  text: string;
  className?: string;
}
interface StyledDivProps {
  backgroundColor: string;
  width: string;
}
interface StyledSpanProps {
  textColor: string;
}
const StyledDiv = styled.div<StyledDivProps>`
  background-color: ${(p) => (theme: any) => theme.theme[p.backgroundColor]};
  width: ${(p) => p.width};
  height: 27px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const StyledSpan = styled.span<StyledSpanProps>`
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 19px;
  display: flex;
  align-items: center;
  text-align: right;
  direction: ltr;
  color: ${(p) => (theme: any) => theme.theme[p.textColor]};
`;
const Badge = (props: Props) => {
  return (
    <StyledDiv
      backgroundColor={props.backgroundColor}
      width={props.width}
      className={props.className || ""}
    >
      <StyledSpan textColor={props.textColor} className={"badge-text"}>
        {props.text}
      </StyledSpan>
    </StyledDiv>
  );
};

export default Badge;
